@for (segment of serviceSegmentItems$ | async; let lastSegment = $last; let i = $index; track segment) {
  @if (i === 0 && safThankYouForJoiningUsNotification$ | async; as safThankYouForJoiningUsNotification) {
    <fin-inform-block
      class="block ms-large-b"
      data-testid="saf-thank-you-for-joining-us"
      [title]="safThankYouForJoiningUsNotification.teaserTitle"
    >
      <cms-unstyled-fragment
        class="block ms-xsmall-y ms-xlarge-l"
        [cmsContent$]="safThankYouForJoiningUsNotification$"
        [showTitle]="false"
      />
    </fin-inform-block>
  }

  <fin-included-product-heading
    class="block ps-xsmall-y nordic-blue-25-bg rounded-medium ms-medium-b"
    [locationCodes]="[segment.departure.locationCode, segment.arrival.locationCode]"
    [operatedByText]="
      (hasNonAySegments$ | async) ? ('operatedBy' | finLocalization: [segment.operatingAirline.name]) : ''
    "
    [locations]="(cartOrOrder$ | async).locations"
  />
  @if (showUpsellPerPax && service.category === Category.LOUNGE && service.upsell?.hasPlusTierBenefit === true) {
    <fin-inform-block
      class="block ms-medium-b"
      [title]="'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.title' | finLocalization"
    >
      <ul class="list-disc-style">
        <li>{{ 'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.child' | finLocalization }}</li>
        <li>{{ 'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.guest' | finLocalization }}</li>
      </ul>
    </fin-inform-block>
  }

  @if (segment.complimentaryServices.length > 0) {
    <fin-inform-block
      class="block ms-medium-b"
      [title]="'MMB.includedProducts.availableForSell.meal.infoTitle' | finLocalization"
    >
      @for (item of segment.complimentaryServices; track item) {
        <ul class="list-disc-style">
          <li>{{ item.displayName }}</li>
        </ul>
      }
    </fin-inform-block>
  }

  @if (segment.operatingAirline.code !== 'AY' && showUpsellPerPax && service.category === Category.SEAT) {
    <ng-container>
      <div class="flex alert-50-bg ps-medium ms-medium-y rounded-medium">
        <fcom-icon class="icon-medium ms-small-r" [name]="SvgLibraryIcon.ALERT_TRIANGLE" />
        <div class="font-body-1">
          {{ 'MMB.includedProducts.availableForSell.seat.notAY' | finLocalization }}
        </div>
      </div>
    </ng-container>
  }

  @if (segment.operatingAirline.code === 'AY' || service.category !== Category.SEAT || showNonAYSeats) {
    <ul class="no-list-style">
      @for (pax of segment.passengers; let lastPassenger = $last; let i = $index; track pax) {
        <li
          [attr.data-testid]="'included-service-' + service.category + '-pax-' + i"
          [ngClass]="{
            'pr-xsmall-t': !showUpsellPerPax,
            'pr-xxsmall-t': showUpsellPerPax,
            'border-bottom-dotted':
              (!lastPassenger && !showUpsellPerPax) ||
              (lastPassenger && includeSeatActionButtons && service.category === Category.SEAT),
            'pr-small-b':
              !lastPassenger ||
              !lastSegment ||
              (lastPassenger && includeSeatActionButtons && service.category === Category.SEAT),
          }"
        >
          <div class="ms-small-l relative">
            @if ((pax.passengerTypeCode !== FinnairPassengerCode.INF && showUpsellPerPax) || !showUpsellPerPax) {
              <div data-hj-suppress class="font-body-1 pax-info nordic-blue-300-text bold-type ms-medium-b ms-xlarge-l">
                <ng-container *ngTemplateOutlet="paxInfo; context: { pax: pax, isNewUpsell: showUpsellPerPax }" />
              </div>
            }

            <fin-grouped-services
              class="block"
              [class.mr-xsmall-l]="!showUpsellPerPax"
              [category]="service.category"
              [groupedServices]="pax.groupedServices"
              [enableUpsellMMB]="showUpsellPerPax"
              [isInfant]="pax.passengerTypeCode === FinnairPassengerCode.INF"
              [isCarrierConnect]="isCarrierConnect"
              [serviceModifyProgress]="serviceModifyProgress().modifyInProgress"
              (selectProduct)="onSelectProduct($event, pax.id, segment.id)"
              (continuePurchase)="onContinuePurchase()"
              (removeProduct)="onRemoveProduct($event, pax.id, segment.id)"
              [mode]="mode"
            />
          </div>
        </li>
      }
    </ul>
  }
  @if (lastSegment && service.category === Category.SAF) {
    <div class="border-top ms-small-y">
      <cms-unstyled-fragment
        data-testid="saf-each-of-your-contributions"
        class="block ms-small-l ms-small-t"
        [contentUrl$]="'fragments.eachOfYourContributions.url' | finLocalization | finToObservable"
        [showTitle]="false"
      />

      <fcom-link
        data-testid="saf-impact-contribution"
        class="block bold-type ms-small-l ms-medium-t"
        (afterNavigation)="isModalOpened = true"
      >
        {{ 'ancillaries.saf.impactOfContributionTitle' | finLocalization }}
      </fcom-link>
      @if (safProductInfo$ | async; as safProductInfo) {
        <fcom-modal [(open)]="isModalOpened" [title]="safProductInfo.teaserTitle">
          @if (safProductInfo.picture) {
            <fcom-image [imageData]="safProductInfo.picture" [ratio]="'21x9'" />
          }

          <div class="pr-medium">
            <h3 class="font-heading-4 ms-large-b ps-large-b border-bottom" data-testid="impact-saf-thank-you">
              {{ 'ancillaries.saf.contributionThankYouTitle' | finLocalization }}
            </h3>
            <cms-unstyled-fragment [showTitle]="false" [cmsContent$]="safProductInfo$" />
            <fcom-link
              data-testid="read-more-saf-impact"
              class="block external-link bold-type ms-xlarge-t ms-medium-be"
              [href]="'ancillaries.saf.readMore.url' | finLocalization"
              [external]="true"
              [openInNewTab]="true"
              >{{ 'ancillaries.saf.readMore.text' | finLocalization }}</fcom-link
            >
          </div>
        </fcom-modal>
      }
    </div>
  }
  @if (includeSeatActionButtons && service.category === Category.SEAT && lastSegment) {
    <ng-container [ngTemplateOutlet]="seatButtons" />
  }
}

<ng-template #paxInfo let-pax="pax" let-isNewUpsell="isNewUpsell">
  @if (!pax.associatedInfantName) {
    <ng-container>{{ pax.firstName }} {{ pax.lastName }}</ng-container>
  }
  @if (pax.associatedInfantName) {
    <ng-container>
      @if (isNewUpsell) {
        {{ pax.firstName }} {{ pax.lastName }} ({{
          'passenger.withInfant'
            | finLocalization: { withInfantFullName: pax.associatedInfantName }
            | finToLowerCase: ''
        }})
      } @else {
        {{
          'MMB.labels.travellingWithInfant'
            | finLocalization
              : { firstName: pax.firstName, lastName: pax.lastName, infantName: pax.associatedInfantName }
        }}
      }
    </ng-container>
  }
</ng-template>

<ng-template #seatButtons>
  <div class="flex flex--end flex--wrap seat-buttons">
    <fcom-button
      data-testid="seats-update-button"
      class="mr-xxsmall-b"
      [mode]="ButtonMode.FILL_MOBILE"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [text]="'MMB.checkIn.steps.seats.viewOrModify' | finLocalization"
      (clickBtn)="viewSeatmap.emit()"
    />
  </div>
</ng-template>
